/* CENTRIX product page progressive enhancement. Native product form remains functional. */
(() => {
  const init = (root) => {
    if (root.dataset.cxReady === 'true') return;
    root.dataset.cxReady = 'true';
    const slides = [...root.querySelectorAll('[data-cx-slide]')];
    const thumbs = [...root.querySelectorAll('[data-cx-thumb]')];
    let activeIndex = Math.max(0, slides.findIndex(slide => !slide.hidden));
    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== activeIndex;
        if (i !== activeIndex) slide.querySelectorAll('video').forEach(video => video.pause());
      });
      thumbs.forEach((thumb, i) => {
        const chosen = i === activeIndex;
        thumb.classList.toggle('is-active', chosen);
        thumb.setAttribute('aria-pressed', String(chosen));
      });
      const counter = root.querySelector('[data-cx-slide-count]');
      if (counter) counter.textContent = `${activeIndex + 1} / ${slides.length}`;
      const activeThumb = thumbs[activeIndex];
      const thumbStrip = activeThumb?.parentElement;
      if (activeThumb && thumbStrip && typeof thumbStrip.scrollTo === 'function') {
        const target = activeThumb.offsetLeft - thumbStrip.offsetLeft - (thumbStrip.clientWidth - activeThumb.clientWidth) / 2;
        thumbStrip.scrollTo({left:target, behavior:'smooth'});
      }
    };
    root.querySelector('[data-cx-prev]')?.addEventListener('click', () => showSlide(activeIndex - 1));
    root.querySelector('[data-cx-next]')?.addEventListener('click', () => showSlide(activeIndex + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showSlide(i)));
    let touchStartX = null;
    const gallery = root.querySelector('[data-cx-gallery]');
    gallery?.addEventListener('touchstart', e => { if (e.touches.length === 1) touchStartX = e.touches[0].clientX; }, {passive:true});
    gallery?.addEventListener('touchend', e => {
      if (touchStartX === null || !e.changedTouches.length) return;
      const delta = e.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) > 65 && !e.target.closest('video,iframe,model-viewer')) showSlide(activeIndex + (delta < 0 ? 1 : -1));
    }, {passive:true});

    const variantJSON = root.querySelector('[data-cx-variants]')?.textContent;
    let variants = [];
    try { variants = variantJSON ? JSON.parse(variantJSON) : []; } catch(error) { console.warn('CENTRIX: variant data unavailable',error); }
    const optionGroups = [...root.querySelectorAll('[data-cx-option-position]')];
    const variantInput = root.querySelector('[data-cx-variant-id]');
    const price = root.querySelector('[data-cx-price]');
    const compare = root.querySelector('[data-cx-compare]');
    const add = root.querySelector('[data-cx-add]');
    const addLabel = root.querySelector('[data-cx-add-label]');
    const status = root.querySelector('[data-cx-availability]');
    const quantity = root.querySelector('[data-cx-quantity]');
    const locale = document.documentElement.lang || 'en-US';
    const currency = root.dataset.currency || 'USD';
    const formatPrice = (value) => {
      try { return new Intl.NumberFormat(locale, {style:'currency', currency}).format(value / 100); }
      catch { return (value / 100).toFixed(2); }
    };
    const getSelections = () => optionGroups.map(group => group.querySelector('input:checked')?.value || '');
    const updateVariant = () => {
      const selected = getSelections();
      const variant = variants.find(v => v.options?.every((value, index) => value === selected[index]));
      // A product with only the default variant does not have option radio groups.
      const resolved = variant || (optionGroups.length === 0 ? variants[0] : null);
      if (variantInput) variantInput.value = resolved?.id || '';
      if (price) price.textContent = resolved ? formatPrice(resolved.price) : 'Unavailable';
      if (compare) {
        const discounted = !!(resolved && resolved.compare_at_price && resolved.compare_at_price > resolved.price);
        compare.hidden = !discounted;
        compare.textContent = discounted ? formatPrice(resolved.compare_at_price) : '';
      }
      const available = !!resolved?.available;
      if (add) add.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Add to Cart' : (resolved ? 'Sold Out' : 'Unavailable');
      if (status) status.textContent = available ? '' : (resolved ? 'This variant is currently unavailable.' : 'This combination is unavailable.');
      if (quantity && resolved) {
        const rules = resolved.quantity_rule || {};
        const min = Number(rules.min) || 1;
        const step = Number(rules.increment) || 1;
        const max = rules.max == null ? null : Number(rules.max);
        quantity.min = String(min);
        quantity.step = String(step);
        if (max !== null) quantity.max = String(max); else quantity.removeAttribute('max');
        let next = Number(quantity.value) || min;
        next = Math.max(min, min + Math.round((next - min) / step) * step);
        if (max !== null) next = Math.min(max, next);
        quantity.value = String(next);
      }
      if (resolved) {
        const mediaId = resolved.featured_media?.id || resolved.featured_image?.id;
        const mediaIndex = slides.findIndex(slide => slide.dataset.cxMediaId === String(mediaId));
        if (mediaIndex !== -1) showSlide(mediaIndex);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', resolved.id);
        window.history.replaceState({...history.state}, '', url);
      }
    };
    optionGroups.forEach(group => group.addEventListener('change', updateVariant));
    const changeQty = (direction) => {
      if (!quantity) return;
      const min = Math.max(1, Number(quantity.min) || 1);
      const max = quantity.max ? Number(quantity.max) : Infinity;
      const step = Math.max(1, Number(quantity.step) || 1);
      const current = Number(quantity.value) || min;
      quantity.value = String(Math.min(max, Math.max(min, current + direction * step)));
    };
    root.querySelector('[data-cx-qty-minus]')?.addEventListener('click', () => changeQty(-1));
    root.querySelector('[data-cx-qty-plus]')?.addEventListener('click', () => changeQty(1));
    if (variants.length) {
      const initialId = JSON.parse(root.querySelector('[data-cx-initial-variant]')?.textContent || 'null');
      const initial = variants.find(v => String(v.id) === String(initialId));
      if (initial && optionGroups.length) {
        optionGroups.forEach((group, index) => {
          const input = [...group.querySelectorAll('input')].find(el => el.value === initial.options[index]);
          if (input) input.checked = true;
        });
      }
      updateVariant();
    }
  };
  const start = () => document.querySelectorAll('[data-cx-product-page]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);
  else start();
  document.addEventListener('shopify:section:load',start);
})();
